<div class="dynamic_input_container" [formGroup]="form">
  @if (control?.fieldInfo.dataType === DynamicFromConstants.PICKLIST) {
    <app-autocomplete-dropdown
      [id]="control.label"
      [placeholder]="control?.placeHolder"
      [formControlName]="control.label"
      [apiUrl]="control?.fieldInfo?.lookupDetails?.apiUrl"
      [selectFields]="control?.fieldInfo?.lookupDetails?.selectFields"
      [filterByKeys]="control?.fieldInfo?.lookupDetails?.filterByKeys"
      [limit]="control?.fieldInfo?.lookupDetails?.limit"
      [orderBy]="control?.fieldInfo?.lookupDetails?.orderBy"
      [bindLabel]="control?.fieldInfo?.lookupDetails?.bindLabel"
      [bindValue]="control?.fieldInfo?.lookupDetails?.bindValue"
      [displayColumns]="control?.fieldInfo?.lookupDetails?.displayColumns"
      [additionalFilters]="control?.fieldInfo?.lookupDetails?.additionalFilters"
      [multiSelect]="control?.fieldInfo?.lookupDetails?.multiSelect"
      [readonly]="isControlReadOnly"
      [disable]="isControlDisabled"
      [returnRawValue]="control?.returnRawValue ?? true"
      [allowCustomInput]="control?.fieldInfo?.lookupDetails?.allowCustomInput ?? false"
      (suggestionSelected) = "onSuggestionSelected($event)"
      (customInputSelected)="onCustomInputSelected($event)"
      (searchCleared) = "onFormValueCleared()"
    >
    </app-autocomplete-dropdown>
  }
  @else if (control?.fieldInfo?.dataType === DynamicFromConstants.BOOLEAN) {
    <app-toggle
    [id]="control.label"
    [formControlName]="control.label"
    [label]="control?.displayLabel"
    [disable]="isControlDisabled"
    [toggleId]="control.label"
    [isActive]="form.get(control.label)?.value"
    (toggleChange)="onChange($event)"
    ></app-toggle>
  } @else if (control?.fieldInfo?.dataType === DynamicFromConstants.TEXTAREA) {
    <textarea [id]="control.label" [placeholder]="control?.placeHolder"
              [formControlName]="control.label"
              [disabled]="isControlDisabled"
              [readOnly]="isControlReadOnly"
              [ngClass]="{'form_error': this.form.get(this.control.label)?.invalid && this.form.get(this.control.label)?.touched && this.form.get(this.control.label)?.errors}"
    ></textarea>
  } @else if (control?.fieldInfo?.dataType === DynamicFromConstants.MULTI_SELECT || control?.fieldInfo?.dataType === DynamicFromConstants.SELECT) {
    <app-multi-select
        [id]="control.label"
        [options]="control?.fieldInfo?.options"
        [displayKey] = "control?.fieldInfo?.displayKey || 'label'"
        [valueKey] = "control?.fieldInfo?.valueKey || 'value'"
        [isMultiSelect]="control?.fieldInfo?.dataType === 'multi-select'"
        [placeholder]="control?.placeHolder"
        [disable]="isControlDisabled"
        [readOnly]="isControlReadOnly"
        [formControlName]="control.label"
        [returnRawValue]="control?.returnRawValue ?? false"
        (selectionChange)="onChange($event)"
        (onClearSelection)="onFormValueCleared()"
      ></app-multi-select>
  } @else if (control?.fieldInfo?.dataType === DynamicFromConstants.CHIP_INPUT) {
    <app-chip-input
        [id]="control.label"
        [placeholder]="control?.placeHolder"
        [formControlName]="control.label"
      ></app-chip-input>
  } @else if (control?.fieldInfo?.dataType === DynamicFromConstants.DATE || control?.fieldInfo?.dataType  === DynamicFromConstants.DATETIME_LOCAL) {
    <app-date-picker
        [id]="control.label"
        [type]="control?.fieldInfo?.dataType"
        [placeholder]="control?.placeHolder"
        [formControlName]="control.label"
        [readonly]="isControlReadOnly"
        [disabled]="isControlDisabled"
        [defaultToCurrentDate]="control?.fieldInfo?.defaultToCurrentDate"
      ></app-date-picker>
  } @else if (control.fieldInfo?.dataType === DynamicFromConstants.DATE_RANGE || control.fieldInfo?.dataType === DynamicFromConstants.DATETIME_LOCAL_RANGE) {
    <app-date-range-picker
      [id]="control.label"
      [showTime]="control.fieldInfo.dataType === DynamicFromConstants.DATETIME_LOCAL_RANGE"
      [formControlName]="control.label"
      [readonly]="isControlReadOnly"
      [disabled]="isControlDisabled"
      (dateRangeChange)="onChange($event)"
    ></app-date-range-picker>
  } @else if (control.fieldInfo?.dataType === DynamicFromConstants.CRON){
    <nz-cron-expression
      [id]="control.label"
      [formControlName]="control.label"
      [nzDisabled]="isControlDisabled"
    ></nz-cron-expression>
  } @else {
    <input
      [id]="control.label"
      [type]="control?.fieldInfo?.dataType"
      [placeholder]="control?.placeHolder || ''"
      autocomplete="off"
      [ngClass]="{'form_error': form.get(control.label)?.invalid && form.get(control.label)?.touched && form.get(control.label)?.errors}"
      [formControlName]="control.label"
      [readonly]="isControlReadOnly"
      [codeFormat]="control?.fieldInfo?.codeFormat ?? false"
      [max]="control?.maxValue"
      [min]="control?.minValue"
    >
  }
  <div class="form_validation_error_new" [ngClass]="{'visible': this.form.get(this.control.label)?.invalid && this.form.get(this.control.label)?.touched}">
    @for (error of control?.validators; track error.type) {
      <small *ngIf="form.get(control.label)?.errors?.[error.type]">
        {{ error.message }}
      </small>
    }
  </div>
</div>
